import React from "react";

const GoogleTranslator = () => {
  return <div id="google_translate_element"></div>;
};

export default GoogleTranslator;
